module.exports = __webpack_public_path__ + "img/vn.acbd7b77.svg";